import React from 'react';
import WP3Dropdown from "../utilities/Dropdown";
import { IconButton } from "../buttons";
import { EmailDisplayContents } from "./types";
import { openConfirmModal } from "../modals/ConfirmModal";

export type EmailFilingButtonProps = {
    email: EmailDisplayContents
    onFile?: ((email: EmailDisplayContents) => void) | null
    onUnFile?: ((email: EmailDisplayContents) => void) | null
};

const EmailFilingButton = ({ email, onFile = null, onUnFile = null } : Readonly<EmailFilingButtonProps>) => {
    const { isFiled, isAssignedToProject } = email;
    const buttonIcon: string = isFiled ? "file-circle-check" : "file-circle-xmark";
    const buttonVariant: ThemeVariant = isFiled ? isAssignedToProject ? "success" : "warning" : "danger";
    const buttonMenu = React.useMemo(() => {
        if (isFiled) {
            return (
                <WP3Dropdown.Menu>
                    <WP3Dropdown.MenuItem
                        icon={['fas', 'trash']}
                        text={"Un-File this Email"}
                        variant={"danger"}
                        onClick={() => {
                            if (onUnFile) {
                                onUnFile(email);
                            }
                        }}
                    />
                </WP3Dropdown.Menu>
            )
        }
        return null;
    }, [ isFiled, isAssignedToProject ]);

    const handleOnFileClick = async () => {
        const isFiling : boolean = isFiled ? await openConfirmModal({
            dialogTitle: "Re-file Email?",
            message: "This email has already been filed. Are you sure you want to re-file it to a different account and/or project?",
            confirmButtonText: "Yes, Re-file",
        }) : true;

        if (!isFiling) {
            return;
        }
        if (onFile) {
            onFile(email);
        }
    };

    return (
        <IconButton
            variant={buttonVariant}
            icon={buttonIcon}
            size="sm"
            menu={buttonMenu}
            onClick={handleOnFileClick}
        ></IconButton>
    );
};

export default EmailFilingButton;